import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=060a020a&scoped=true"
import script from "./LoadingSpinner.js?vue&type=script&lang=js&external"
export * from "./LoadingSpinner.js?vue&type=script&lang=js&external"
import style0 from "./LoadingSpinner.scss?vue&type=style&index=0&id=060a020a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060a020a",
  null
  
)

export default component.exports